import useMemberSummary from "../../../hooks/use-member-summary";
import StatCard from "../../../components/StatCard";
import { StatSummary } from "../../../components/StatSummary";
import ChartCard from '../../../components/chart/chart-card';
import Grid from "@mui/material/Grid";
import DoughnutChart from '../../../components/chart/doughnut-chart';
import { PeopleIcon } from "../../../shared/icons";

const getColorForGender = (gender: string) => {
    switch (gender) {
        case 'Male':
            return '#2964d6';
        case 'Female':
            return '#ff0081';
        default:
            return '#eacaf4';
    }
}

export const getColorForMembershipStatus = (status: string) => {
    switch (status) {
        case 'Active':
            return '#00C49F';
        case 'Expired':
            return '#ed2f4f';
        default:
            return '#eacaf4';
    }
}

const MemberSummary = () => {
    const memberSummary = useMemberSummary();

    return (
        <div>
            {memberSummary &&
                <>
                    <StatSummary>
                        <StatCard title="Total Count" value={memberSummary?.totalCount.toString()} icon={PeopleIcon} />
                        <StatCard title="Joined This Month" value={memberSummary?.currentMonthCount.toString()} icon={PeopleIcon} />
                        <StatCard title="Joined Last Month" value={memberSummary?.lastMonthCount.toString()} icon={PeopleIcon} />
                        <StatCard title="Expire Next 7 Days" value={memberSummary?.expireNext7Days.toString()} icon={PeopleIcon} />
                        {/* <StatCard title="Expired" value={memberSummary?.expiredCount.toString()} icon={HourglassTopIcon} /> */}
                    </StatSummary>
                    <Grid container direction="row" justifyContent="flex-start">
                        <Grid size={{ lg: 3, md: 6, sm: 12, xs: 12 }}>
                            <ChartCard><DoughnutChart data={memberSummary.countByGender.map(item => { return { name: item.key, value: item.value, color: getColorForGender(item.key) } })} label='Gender' /></ChartCard>
                        </Grid>
                        <Grid size={{ lg: 3, md: 6, sm: 12, xs: 12 }}>
                            <ChartCard><DoughnutChart data={memberSummary.countByMembershipStatus.map(item => { return { name: item.key, value: item.value, color: getColorForMembershipStatus(item.key) } })} label='Membership Status' /></ChartCard>
                        </Grid>
                        <Grid size={{ lg: 3, md: 6, sm: 12, xs: 12 }}>
                            <ChartCard><DoughnutChart data={memberSummary.countByMembership.map(item => { return { name: item.key, value: item.value } })} label='Membership Type' hideLegend={memberSummary.countByMembership.length > 5} /></ChartCard>
                        </Grid>
                        <Grid size={{ lg: 3, md: 6, sm: 12, xs: 12 }}>
                            <ChartCard><DoughnutChart data={memberSummary.countByAge.map(item => { return { name: item.key, value: item.value } })} label='Age' /></ChartCard>
                        </Grid>
                        {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                            <ChartCard title='test'><LinesChart /></ChartCard>
                        </Grid> */}
                    </Grid>
                </>
            }
        </div>
    )
}

export default MemberSummary;